module.exports = __webpack_public_path__ + "img/guia01.a65b08e1.svg";